module.exports = __webpack_public_path__ + "static/img/banner3.e939a76a.png";